 
/* Initialize wishlist
  wslst() {
    productsCookieList();
  }

  // Enable wishlist
    vndHlp.wslst();


    productsCookieList(setting);
    var list = localStorage.getItem("vnd_cplst");
    if ( list != null ) {
      $('.compare-grid').show();
    }
  }
*/
document.addEventListener("DOMContentLoaded", function() {
  
function productsCookieList(t) {
    let e = $.extend({
        type: "vndWslst",
        btnClass: ".btn-wishlist",
        listItem: ".wishlist-card",
        listCount: ".wishlist-count",
        listGrid: ".wishlist-grid",
        pageClass: ".page-wishlist",
        removeAll: ".clear-wishlist",
        ajaxTarget: "?view=wishlist_item_html"
    }, t);
    const i = $(e.btnClass)
      , n = ($(e.listItem),
    $(e.listCount));
    let o = localStorage.getItem(e.type) || [];
    o.length > 0 && (o = JSON.parse(o));
    const s = function(t) {
        const i = t.dataset.productHandle;
        if (i) {
            const n = $(t).hasClass("is-active")
              , s = t.querySelector("span");
            if (n) {
                s && (s.innerText = t.title);
                const n = o.indexOf(i);
                o.splice(n, 1),
                localStorage.setItem(e.type, JSON.stringify(o))
            } else
                s && (s.innerText = t.dataset.removeTitle),
                o.push(i),
                localStorage.setItem(e.type, JSON.stringify(o));
            r()
        }
    }
      , r = function() {
        n.text(o.length),
        o.length > 0 ? n.show() : $(".header").find(n).hide()
    };
  
  
    i.click(function(t) {
        t.preventDefault(),
        s(this),
        $(this).toggleClass("is-active")
    }),
    i.each(function() {
        const t = this.dataset.productHandle;
        if (o.indexOf(t) > -1) {
            const t = this.querySelector("span");
            t && (t.innerText = this.dataset.removeTitle),
            $(this).addClass("is-active")
        }
    }),
    $(e.pageClass).length > 0 && (function() {
        const t = "grid-items__" + $(e.listGrid).data("grid-items");
        for (let i = 0; i < o.length; i++) {
            const n = o[i];
            $.ajax({
                url: "/products/" + n + e.ajaxTarget,
                dataType: "HTML",
                type: "GET",
                success: function(i) {
                    if ("?view=wishlist_item_html" == e.ajaxTarget) {
                        const n = (new DOMParser).parseFromString(i, "text/html").querySelector(".wishlist-card");
                        $(e.listGrid).append(n),
                        $(e.listGrid).find(e.listItem).addClass(t),
                        n.querySelector(e.btnClass).onclick = function(t) {
                            t.preventDefault(),
                            s(this),
                            this.closest(e.listItem).remove()
                        },console.log(e,n,t,s,i)
                    } else {
                        const t = (new DOMParser).parseFromString(i, "text/html");
                        for (let i = 1; i < 7; i++) {
                            const n = ".compare-item__" + i
                              , o = t.querySelector(n);
                            o.classList.remove("compare-item__" + i),
                            $(e.listGrid).find(n).append(o),
                            1 == i && (o.querySelector(e.btnClass).onclick = function(t) {
                                t.preventDefault(),
                                s(this),
                                $(e.listGrid).find("[data-product-handle=" + this.dataset.productHandle + "]").remove()
                            }
                            )
                        }
                    }
                }
            })
        }
        o.length < 1 ? ($(e.removeAll).hide(250),
        $(".page-list__empty").addClass("is-visible")) : ($(".page-list__empty").removeClass("is-visible"),
        $(e.removeAll).css("display", "flex"))
    }(),
    setTimeout(function() {
        $(".result-loading").removeClass("active"),
        o.length > 0 && $(e.listGrid).addClass("is-visible")
    }, 500)),
    r(),
    $(e.removeAll).click(function(t) {
        t.preventDefault(),
        o = [],
        localStorage.setItem(e.type, JSON.stringify(o)),
        $(e.listItem).slideUp("slow", ()=>{
            this.remove(),
            r()
        }
        )
    })
}
    productsCookieList();

});